import React from 'react';
import PropTypes from 'prop-types';
import MenuInputWithTitle from '../../components/MenuInputWithTitle';
import messages from '../messages';

const Fees = ({ onChange, initialValue }) => (
  <React.Fragment>
    {initialValue.applicationFee && (
      <MenuInputWithTitle
        key="applicationFee"
        data-cy="Premium-Hem-Fees-ApplicationFee-InputField"
        type="number"
        min="0"
        max="999999"
        maxLength="6"
        title={messages.applicationFee}
        value={initialValue.applicationFee.value}
        onChange={(e) => {
          onChange(e, {
            applicationFee: { ...initialValue.applicationFee, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.applicationFee.showError}
      />
    )}
    {initialValue.deposit && (
      <MenuInputWithTitle
        key="deposit"
        data-cy="Premium-Hem-Fees-Deposit-InputField"
        type="number"
        min="0"
        max="999999"
        maxLength="6"
        title={messages.deposit}
        value={initialValue.deposit.value}
        onChange={(e) => {
          onChange(e, {
            deposit: { ...initialValue.deposit, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.deposit.showError}
      />
    )}
    {initialValue.transferApplicationFee && (
      <MenuInputWithTitle
        key="transferApplicationFee"
        data-cy="Premium-Hem-Fees-TransferApplicationFee-InputField"
        type="number"
        min="0"
        max="999999"
        maxLength="6"
        title={messages.transferApplicationFee}
        value={initialValue.transferApplicationFee.value}
        onChange={(e) => {
          onChange(e, {
            transferApplicationFee: { ...initialValue.transferApplicationFee, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.transferApplicationFee.showError}
      />
    )}
    {initialValue.transferDepositFee && (
      <MenuInputWithTitle
        key="transferDepositFee"
        data-cy="Premium-Hem-Fees-TransferDepositFee-InputField"
        type="number"
        min="0"
        max="999999"
        maxLength="6"
        title={messages.transferDepositFee}
        value={initialValue.transferDepositFee.value}
        onChange={(e) => {
          onChange(e, {
            transferDepositFee: { ...initialValue.transferDepositFee, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.transferDepositFee.showError}
      />
    )}
    {initialValue.internationalApplicationFee && (
      <MenuInputWithTitle
        key="internationalApplicationFee"
        data-cy="Premium-Hem-Fees-InternationalApplicationFee-InputField"
        type="number"
        min="0"
        max="999999"
        maxLength="6"
        title={messages.internationalApplicationFee}
        value={initialValue.internationalApplicationFee.value}
        onChange={(e) => {
          onChange(e, {
            internationalApplicationFee: { ...initialValue.internationalApplicationFee, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.internationalApplicationFee.showError}
      />
    )}
    {initialValue.internationalDepositFee && (
      <MenuInputWithTitle
        key="internationalDepositFee"
        data-cy="Premium-Hem-Fees-InternationalDepositFee-InputField"
        type="number"
        min="0"
        max="999999"
        maxLength="6"
        title={messages.internationalDepositFee}
        value={initialValue.internationalDepositFee.value}
        onChange={(e) => {
          onChange(e, {
            internationalDepositFee: { ...initialValue.internationalDepositFee, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.internationalDepositFee.showError}
      />
    )}
  </React.Fragment>
);

Fees.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default Fees;
